import { render, staticRenderFns } from "./LiveAnswer.vue?vue&type=template&id=7d223c5e&scoped=true"
import script from "./LiveAnswer.vue?vue&type=script&lang=js"
export * from "./LiveAnswer.vue?vue&type=script&lang=js"
import style0 from "./LiveAnswer.vue?vue&type=style&index=0&id=7d223c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d223c5e",
  null
  
)

export default component.exports